module.exports = __webpack_public_path__ + "img/2cc35df.jpeg";